import React from "react";
import { Building2 } from "lucide-react";
import { EntityCombobox } from "@/components/ui/entity-combobox";

const label = (c) => c.nombre || c.razon_social || "—";
const secondary = (c) => [
  c.razon_social && c.razon_social !== c.nombre ? c.razon_social : null,
  c.cif,
  c.codigo_factusol ? `cód. ${c.codigo_factusol}` : null,
].filter(Boolean).join(" · ");
const searchText = (c) => [
  c.nombre, c.razon_social, c.nombre_comercial, c.alias, c.cif, c.codigo_factusol, c.email_contacto,
].filter(Boolean).join(" ");

/** Selector de Cliente con búsqueda (nombre, razón social, alias, CIF, código Factusol). */
export default function ClienteCombobox({
  value, onChange, clientes = [], placeholder = "Buscar cliente…", testId = "cliente-combobox",
  disabled = false, className = "", allowNone = false, noneLabel = "— Sin cliente", getBadge, recentsKey = "clientes",
}) {
  return (
    <EntityCombobox
      value={value || ""}
      onChange={onChange}
      items={clientes}
      getLabel={label}
      getSecondary={secondary}
      getSearchText={searchText}
      getBadge={getBadge}
      icon={Building2}
      placeholder={placeholder}
      searchPlaceholder="Nombre, razón social, CIF, código…"
      emptyText="Ningún cliente coincide"
      allowNone={allowNone}
      noneLabel={noneLabel}
      disabled={disabled}
      testId={testId}
      className={className}
      recentsKey={recentsKey}
      secondaryInTrigger={false}
    />
  );
}
